import React from "react";
import { Link } from "react-router-dom";
import indiaEmblem from "../assets/Jharkhand_logo.jpg";
import jharkhandLogo from "../assets/Jharkhand_logo.jpg";
import panchayatiRajLogo from "../assets/panchayti_raj.jpg";

export default function GlobalHeader() {
  return (
    <>
      {/* Top Header Section */}
      <header className="w-full bg-white py-3 border-b border-gray-200">
        <div className="max-w-[1400px] mx-auto px-4 flex justify-between items-center">
          {/* Left side logos & text */}
          <div className="flex items-center gap-4">
            <img src={indiaEmblem} alt="India Emblem" className="h-20" />
            <div className="flex flex-col text-slate-800">
              <span className="text-xl font-bold font-sans">पंचायती राज विभाग, झारखंड सरकार</span>
              <span className="text-lg font-bold">Department of Panchayati Raj,</span>
              <span className="text-sm font-semibold">Government of Jharkhand</span>
            </div>
          </div>

          {/* Right side logos */}
          <div className="flex items-center gap-4 hidden md:flex">
            <img src={panchayatiRajLogo} alt="Panchayati Raj" className="h-16" />
            <img src={jharkhandLogo} alt="Jharkhand Government" className="h-16" />
          </div>
        </div>
      </header>

      {/* Navigation Bar */}
      <nav className="w-full bg-[#1e9653]">
        <div className="max-w-[1400px] mx-auto px-4">
          <div className="flex items-center justify-between text-white text-[13px] font-semibold h-12">
            <ul className="flex items-center space-x-6 overflow-x-auto whitespace-nowrap scrollbar-hide">
              <li className="cursor-pointer hover:text-gray-200">
                <Link to="/">HOME</Link>
              </li>
              <li className="cursor-pointer hover:text-gray-200">ABOUT US ▾</li>
              <li className="cursor-pointer hover:text-gray-200">15 FINANCE COMMISSION ▾</li>
              <li className="cursor-pointer hover:text-gray-200">PESA ▾</li>
              <li className="cursor-pointer hover:text-gray-200">PRI ▾</li>
              <li className="cursor-pointer hover:text-gray-200">GPDP ▾</li>
              <li className="cursor-pointer hover:text-gray-200">SCHEME ▾</li>
              <li className="cursor-pointer hover:text-gray-200">E-GOVERNANCE ▾</li>
              <li className="cursor-pointer hover:text-gray-200">PANCHAYAT</li>
              <li className="cursor-pointer hover:text-gray-200">PHOTO GALLERY</li>
              <li className="cursor-pointer hover:text-gray-200">NOTIFICATIONS</li>
              <li className="cursor-pointer hover:text-gray-200">NEWSLETTER</li>
            </ul>
            <div className="ml-4 flex-shrink-0">
              <Link to="/login" className="cursor-pointer hover:text-gray-200 uppercase">
                LOGIN
              </Link>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}
